import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AUINotificationContext } from '@ancert/aui-notification-context';

import Routes from './routes';

import { HOMEPAGE } from './constants/routes.constants';

import '@ancert/aui-styles/prime.scss';
import '@ancert/aui-styles/styles.scss';
import './assets/themes/portales.css'; // Este fichero no se debe modificar
import './assets/styles/global-overrides.css'; // Estilos globales personalizados
import Layout from './containers/Layout';

/**
 * @component
 * @returns {React.ReactElement} - Devuelve un componente Layout
 */
function App() {
  return (
    <BrowserRouter basename={HOMEPAGE}>
      <AUINotificationContext>
        <Layout>
          <Routes />
        </Layout>
      </AUINotificationContext>
    </BrowserRouter>
  );
}

export default App;
